import { Grid, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useMutation } from 'react-query';
import * as api from '../../api/app/opcClientApi';
import { Loader } from '../../components/core/Loader/Loader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { dictionary } from '../../utils/core/dictionary';
import { BrowseOpcUaForm } from './BrowseOpcUaForm';

export function BrowseOpcUa() {
  const { enqueueSnackbar } = useSnackbar();
  const [endpointAddress, setEndpointAddress] = useState<string>('');
  const [data, setData] = useState<string[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { mutate: mutateBrowse } = useMutation(api.browse);

  const handleSubmit = () => {
    if (endpointAddress.length < 1) return;
    setLoading(true);
    mutateBrowse(endpointAddress, {
      onSuccess: (res) => {
        setData(res);
        setLoading(false);
        enqueueSnackbar('Success', { variant: 'success' });
      },
      onError: (result: any) => {
        setData(null);
        setLoading(false);
        enqueueSnackbar(`${result}`, { variant: 'error' });
      },
    });
  };

  if (loading) return <Loader />;

  return (
    <>
      <PageHeader title={dictionary.BROWSE_OPC_UA} xs={6} />
      <PageContent>
        <BrowseOpcUaForm onSubmit={handleSubmit} setEndpointAddress={setEndpointAddress} />
        {data && data?.length > 0 && (
          <Grid item mt={5}>
            <Typography variant="h4">{dictionary.NODES}</Typography>
            {data.map((node: string, index: number) => (
              <Typography key={index} variant="body1">
                {node}
              </Typography>
            ))}
          </Grid>
        )}
      </PageContent>
    </>
  );
}
